import { ConsentModeValue, ConsentMode } from "../types/consent";

const hasConsent = (value: ConsentModeValue | null | undefined): boolean => value === "granted";

export const hasFunctionalityConsent = (consent: ConsentMode | null | undefined): boolean =>
  hasConsent(consent?.functionality_storage);

export const hasAnalyticsConsent = (consent: ConsentMode | null | undefined): boolean =>
  hasConsent(consent?.analytics_storage);

export const hasMarketingConsent = (consent: ConsentMode | null | undefined): boolean =>
  hasConsent(consent?.ad_storage);
